export const types = {
    SET_ONBOARDING_WITH_INVITATION: "onboarding/SET_ONBOARDING_WITH_INVITATION",
    SET_EMAIL: "onboarding/SET_EMAIL",
    REQUEST_VERIFY_USERNAME: "onboarding/REQUEST_VERIFY_USERNAME",
    SUCCESS_VERIFY_USERNAME: "onboarding/SUCCESS_VERIFY_USERNAME",
    FAILURE_VERIFY_USERNAME: "onboarding/FAILURE_VERIFY_USERNAME",
    SET_PASSWORD: "onboarding/SET_PASSWORD",
    SET_DOCUMENT_DATA: "onboarding/SET_DOCUMENT_DATA",
    SET_DOCUMENT_TYPE: "onboarding/SET_DOCUMENT_TYPE",
    TAKE_PICTURE_ERROR: "onboarding/TAKE_PICTURE_ERROR",
    TAKE_PICTURE_REQUEST: "onboarding/TAKE_PICTURE_REQUEST",
    TAKE_PICTURE_SUCCESS: "onboarding/TAKE_PICTURE_SUCCESS",
    UPLOAD_CLIENT_PERSONAL_INFO_REQUEST: "onboarding/UPLOAD_CLIENT_PERSONAL_INFO_REQUEST",
    UPLOAD_CLIENT_PERSONAL_ADDRESS_REQUEST: "onboarding/UPLOAD_CLIENT_PERSONAL_ADDRESS_REQUEST",
    UPLOAD_PICTURE_ERROR: "onboarding/UPLOAD_PICTURE_ERROR",
    UPLOAD_PICTURE_REQUEST: "onboarding/UPLOAD_PICTURE_REQUEST",
    UPLOAD_PICTURE_SUCCESS: "onboarding/UPLOAD_PICTURE_SUCCESS",
    UPLOAD_CLIENT_INFO_AND_SEND_INVITATION_CODE_REQUEST:
        "onboarding/UPLOAD_CLIENT_INFO_AND_SEND_INVITATION_CODE_REQUEST",
    UPLOAD_CLIENT_INFO_AND_SEND_INVITATION_CODE_ERROR: "onboarding/UPLOAD_CLIENT_INFO_AND_SEND_INVITATION_CODE_ERROR",
    UPLOAD_CLIENT_INFO_AND_SEND_INVITATION_CODE_SUCCESS:
        "onboarding/UPLOAD_CLIENT_INFO_AND_SEND_INVITATION_CODE_SUCCESS",
    VERIFY_INVITATION_CODE_ERROR: "onboarding/VERIFY_INVITATION_CODE_ERROR",
    VERIFY_INVITATION_CODE_REQUEST: "onboarding/VERIFY_INVITATION_CODE_REQUEST",
    VERIFY_INVITATION_CODE_SUCCESS: "onboarding/VERIFY_INVITATION_CODE_SUCCESS",
    VERIFY_VERIFICATION_CODE_ERROR: "onboarding/VERIFY_VERIFICATION_CODE_ERROR",
    VERIFY_VERIFICATION_CODE_REQUEST: "onboarding/VERIFY_VERIFICATION_CODE_REQUEST",
    VERIFY_VERIFICATION_CODE_SUCCESS: "onboarding/VERIFY_VERIFICATION_CODE_SUCCESS",
    REQUEST_VERIFICATION_CODE_PRE_ERROR: "onboarding/REQUEST_VERIFICATION_CODE_PRE_ERROR",
    REQUEST_VERIFICATION_CODE_PRE_REQUEST: "onboarding/REQUEST_VERIFICATION_CODE_PRE_REQUEST",
    REQUEST_VERIFICATION_CODE_PRE_SUCCESS: "onboarding/REQUEST_VERIFICATION_CODE_PRE_SUCCESS",
    SAVE_USER_CREDENTIALS: "onboarding/SAVE_USER_CREDENTIALS",
    CLEAN_USER_CREDENTIALS: "onboarding/CLEAN_USER_CREDENTIALS",
    SET_USER_CREDENTIALS_ERROR: "onboarding/SET_USER_CREDENTIALS_ERROR",
    SET_USER_CREDENTIALS_REQUEST: "onboarding/SET_USER_CREDENTIALS_REQUEST",
    SET_USER_CREDENTIALS_SUCCESS: "onboarding/SET_USER_CREDENTIALS_SUCCESS",
    REQUEST_SECURITY_SEALS_ERROR: "onboarding/REQUEST_SECURITY_SEALS_ERROR",
    REQUEST_SECURITY_SEALS_REQUEST: "onboarding/REQUEST_SECURITY_SEALS_REQUEST",
    REQUEST_SECURITY_SEALS_SUCCESS: "onboarding/REQUEST_SECURITY_SEALS_SUCCESS",

    REQUEST_LIST_STATES: "onboarding/REQUEST_LIST_STATES",
    FAILURE_LIST_STATES: "onboarding/FAILURE_LIST_STATES",
    SUCCESS_LIST_STATES: "onboarding/SUCCESS_LIST_STATES",

    REQUEST_LIST_JOBS: "onboarding/REQUEST_LIST_JOBS",
    FAILURE_LIST_JOBS: "onboarding/FAILURE_LIST_JOBS",
    SUCCESS_LIST_JOBS: "onboarding/SUCCESS_LIST_JOBS",

    REQUEST_LIST_OCCUPATIONS: "onboarding/REQUEST_LIST_OCCUPATIONS",
    REQUEST_LIST_SELECTOR_OPTIONS: "onboarding/REQUEST_LIST_SELECTOR_OPTIONS",
    FAILURE_LIST_OCCUPATIONS: "onboarding/FAILURE_LIST_OCCUPATIONS",
    SUCCESS_LIST_OCCUPATIONS: "onboarding/SUCCESS_LIST_OCCUPATIONS",

    REQUEST_VERIFY_CUIT: "onboarding/REQUEST_VERIFY_CUIT",
    FAILURE_VERIFY_CUIT: "onboarding/FAILURE_VERIFY_CUIT",
    SUCCESS_VERIFY_CUIT: "onboarding/SUCCESS_VERIFY_CUIT",

    NEW_OPERATION_VU_REQUEST: "onboarding/NEW_OPERATION_VU_REQUEST",
    NEW_OPERATION_VU_FAILURE: "onboarding/NEW_OPERATION_VU_FAILURE",
    NEW_OPERATION_VU_SUCCESS: "onboarding/NEW_OPERATION_VU_SUCCESS",

    SCAN_DOCUMENT_REQUEST: "onboarding/SCAN_DOCUMENT_REQUEST",
    SCAN_DOCUMENT_REQUEST_BACK: "onboarding/SCAN_DOCUMENT_REQUEST_BACK",
    SCAN_DOCUMENT_FAILURE: "onboarding/SCAN_DOCUMENT_FAILURE",
    SCAN_DOCUMENT_SUCCESS: "onboarding/SCAN_DOCUMENT_SUCCESS",
    SCAN_DOCUMENT_REQUEST_MIGRATION: "onboarding/SCAN_DOCUMENT_REQUEST_MIGRATION",
    SCAN_DOCUMENT_REQUEST_MIGRATION_BACK: "onboarding/SCAN_DOCUMENT_REQUEST_MIGRATION_BACK",
    SCAN_DOCUMENT_SUCCESS_FRONT: "onboarding/SCAN_DOCUMENT_SUCCESS_FRONT",

    CAPTURE_SELFIE_REQUEST: "onboarding/CAPTURE_SELFIE_REQUEST",
    CAPTURE_SELFIE_FAILURE: "onboarding/CAPTURE_SELFIE_FAILURE",
    CAPTURE_SELFIE_SUCCESS: "onboarding/CAPTURE_SELFIE_SUCCESS",

    CAPTURE_SELFIE_MIGRATION: "onboarding/CAPTURE_SELFIE_MIGRATION",
    CAPTURE_SELFIE_MIGRATION_FAILURE: "onboarding/CAPTURE_SELFIE_MIGRATION_FAILURE",
    CAPTURE_SELFIE_MIGRATION_SUCCESS: "onboarding/CAPTURE_SELFIE_MIGRATION_SUCCESS",

    RESET_IDENTITY_VALIDATION_PROGRESS: "onboarding/RESET_IDENTITY_VALIDATION_PROGRESS",

    REQUEST_VERIFY_CODE_SEND: "onboarding/REQUEST_VERIFY_CODE_SEND",
    FAILURE_VERIFY_CODE_SEND: "onboarding/FAILURE_VERIFY_CODE_SEND",
    SUCCESS_VERIFY_CODE_SEND: "onboarding/SUCCESS_VERIFY_CODE_SEND",

    REQUEST_VERIFY_CODE_RECEIVE: "onboarding/REQUEST_VERIFY_CODE_RECEIVE",
    FAILURE_VERIFY_CODE_RECEIVE: "onboarding/FAILURE_VERIFY_CODE_RECEIVE",
    SUCCESS_VERIFY_CODE_RECEIVE: "onboarding/SUCCESS_VERIFY_CODE_RECEIVE",
    REQUEST_VERIFY_CODE_RECEIVE_MIGRATION: "onboarding/REQUEST_VERIFY_CODE_RECEIVE_MIGRATION",
    FAILURE_VERIFY_CODE_RECEIVE_MIGRATION: "onboarding/FAILURE_VERIFY_CODE_RECEIVE_MIGRATION",
    SUCCESS_VERIFY_CODE_RECEIVE_MIGRATION: "onboarding/SUCCESS_VERIFY_CODE_RECEIVE_MIGRATION",
    RESET_VERIFY_CODE: "onboarding/RESET_VERIFY_CODE",

    REQUEST_CREATE_USER: "onboarding/REQUEST_CREATE_USER",
    SUCCESS_CREATE_USER: "onboarding/SUCCESS_CREATE_USER",
    FAILURE_CREATE_USER: "onboarding/FAILURE_CREATE_USER",

    FAILURE_UNSECURE_PASSWORD: "onboarding/FAILURE_UNSECURE_PASSWORD",

    REQUEST_ACCEPT_SCHEME: "onboarding/REQUEST_ACCEPT_SCHEME",
    SUCCESS_ACCEPT_SCHEME: "onboarding/SUCCESS_ACCEPT_SCHEME",
    FAILURE_ACCEPT_SCHEME: "onboarding/FAILURE_ACCEPT_SCHEME",

    REQUEST_LIST_PERSONAL_INFO: "onboarding/REQUEST_LIST_PERSONAL_INFO",
    SUCCESS_LIST_PERSONAL_INFO: "onboarding/SUCCESS_LIST_PERSONAL_INFO",
    FAILURE_LIST_PERSONAL_INFO: "onboarding/FAILURE_LIST_PERSONAL_INFO",

    REQUEST_LIST_LOCALITY: "onboarding/REQUEST_LIST_LOCALITY",
    SUCCESS_LIST_LOCALITY: "onboarding/SUCCESS_LIST_LOCALITY",
    FAILURE_LIST_LOCALITY: "onboarding/FAILURE_LIST_LOCALITY",

    CLEAN_LOCALITY_LIST: "onboarding/CLEAN_LOCALITY_LIST",

    REQUEST_SAVE_PERSONAL_DATA: "onboarding/REQUEST_SAVE_PERSONAL_DATA",
    SUCCESS_SAVE_PERSONAL_DATA: "onboarding/SUCCESS_SAVE_PERSONAL_DATA",
    FAILURE_SAVE_PERSONAL_DATA: "onboarding/FAILURE_SAVE_PERSONAL_DATA",

    REQUEST_GET_PERSONAL_DATA: "onboarding/REQUEST_GET_PERSONAL_DATA",
    SUCCESS_GET_PERSONAL_DATA: "onboarding/SUCCESS_GET_PERSONAL_DATA",
    FAILURE_GET_PERSONAL_DATA: "onboarding/FAILURE_GET_PERSONAL_DATA",

    REQUEST_LIST_REGULATORY_INFO: "onboarding/REQUEST_LIST_REGULATORY_INFO",
    SUCCESS_LIST_REGULATORY_INFO: "onboarding/SUCCESS_LIST_REGULATORY_INFO",
    FAILURE_LIST_REGULATORY_INFO: "onboarding/FAILURE_LIST_REGULATORY_INFO",

    REQUEST_LEGAL_REPRESENTATIVE_INFO: "onboarding/REQUEST_LEGAL_REPRESENTATIVE_INFO",
    SUCCESS_LEGAL_REPRESENTATIVE_INFO: "onboarding/SUCCESS_LEGAL_REPRESENTATIVE_INFO",
    FAILURE_LEGAL_REPRESENTATIVE_INFO: "onboarding/FAILURE_LEGAL_REPRESENTATIVE_INFO",

    // REQUEST_SAVE_REGULATORY_DATA: "onboarding/REQUEST_SAVE_REGULATORY_DATA",
    // SUCCESS_SAVE_REGULATORY_DATA: "onboarding/SUCCESS_SAVE_REGULATORY_DATA",
    // FAILURE_SAVE_REGULATORY_DATA: "onboarding/FAILURE_SAVE_REGULATORY_DATA",

    CLEAN_SCAN_DOCUMENT_FLAG: "onboarding/CLEAN_SCAN_DOCUMENT_FLAG",

    USER_ROLE_REQUEST: "onboarding/USER_ROLE_REQUEST",
    USER_ROLE_SUCCESS: "onboarding/USER_ROLE_SUCCESS",
    USER_ROLE_FAILURE: "onboarding/USER_ROLE_FAILURE",

    NOSIS_CDA_REQUEST: "onboarding/NOSIS_CDA_REQUEST",
    NOSIS_CDA_SUCCESS: "onboarding/NOSIS_CDA_SUCCESS",
    NOSIS_CDA_FAILURE: "onboarding/NOSIS_CDA_FAILURE",
    NOSIS_CDA_RESET: "onboarding/NOSIS_CDA_RESET",

    ONB_INVITATION_CODE_REQUEST: "onboarding/ONB_INVITATION_CODE_REQUEST",
    ONB_INVITATION_CODE_SUCCESS: "onboarding/ONB_INVITATION_CODE_SUCCESS",
    ONB_INVITATION_CODE_FAILURE: "onboarding/ONB_INVITATION_CODE_FAILURE",
    ONB_INVITATION_CODE_RESET: "onboarding/ONB_INVITATION_CODE_RESET",

    SET_ACCEPT_RENAPER_TERMS: "onboarding/SET_ACCEPT_RENAPER_TERMS",
    SET_IDENTITY_VALIDATION_STARTED: "onboarding/SET_IDENTITY_VALIDATION_STARTED",

    SET_MOBILE_NUMBER: "onboarding/SET_SET_MOBILE_NUMBER",

    RESTART_ENVIRONMENT_STORE: "onboarding/RESTART_ENVIRONMENT_STORE",

    VALIDATE_CREDENTIALS_STEP_1_REQUEST: "onboarding/VALIDATE_CREDENTIALS_STEP_1_REQUEST",
    VALIDATE_CREDENTIALS_STEP_1_SUCCESS: "onboarding/VALIDATE_CREDENTIALS_STEP_1_SUCCESS",
    VALIDATE_CREDENTIALS_STEP_1_FAILURE: "onboarding/VALIDATE_CREDENTIALS_STEP_1_FAILURE",

    VALIDATE_CREDENTIALS_STEP_1_MIGRATION_REQUEST: "onboarding/VALIDATE_CREDENTIALS_STEP_1_MIGRATION_REQUEST",
    VALIDATE_CREDENTIALS_STEP_1_MIGRATION_SUCCESS: "onboarding/VALIDATE_CREDENTIALS_STEP_1_MIGRATION_SUCCESS",
    VALIDATE_CREDENTIALS_STEP_1_MIGRATION_FAILURE: "onboarding/VALIDATE_CREDENTIALS_STEP_1_MIGRATION_FAILURE",

    VALIDATE_CREDENTIALS_STEP_2_REQUEST: "onboarding/VALIDATE_CREDENTIALS_STEP_2_REQUEST",
    VALIDATE_CREDENTIALS_STEP_2_SUCCESS: "onboarding/VALIDATE_CREDENTIALS_STEP_2_SUCCESS",
    VALIDATE_CREDENTIALS_STEP_2_FAILURE: "onboarding/VALIDATE_CREDENTIALS_STEP_2_FAILURE",

    VALIDATE_CREDENTIALS_STEP_2_MIGRATION_REQUEST: "onboarding/VALIDATE_CREDENTIALS_STEP_2_MIGRATION_REQUEST",
    VALIDATE_CREDENTIALS_STEP_2_MIGRATION_SUCCESS: "onboarding/VALIDATE_CREDENTIALS_STEP_2_MIGRATION_SUCCESS",
    VALIDATE_CREDENTIALS_STEP_2_MIGRATION_FAILURE: "onboarding/VALIDATE_CREDENTIALS_STEP_2_MIGRATION_FAILURE",

    SET_ONBOARDING_WITH_ENROLLED_USER: "onboarding/SET_ONBOARDING_WITH_ENROLLED_USER",

    ENROLLED_USER_SELECT_ROLE_REQUEST: "onboarding/ENROLLED_USER_SELECT_ROLE_REQUEST",
    ENROLLED_USER_SELECT_ROLE_FAILURE: "onboarding/ENROLLED_USER_SELECT_ROLE_FAILURE",
    ENROLLED_USER_SELECT_ROLE_SUCCESS: "onboarding/ENROLLED_USER_SELECT_ROLE_SUCCESS",

    REQUEST_MIGRATION_UPDATE_USER: "onboarding/REQUEST_MIGRATION_UPDATE_USER",
    SUCCESS_MIGRATION_UPDATE_USER: "onboarding/SUCCESS_MIGRATION_UPDATE_USER",
    FAILURE_MIGRATION_UPDATE_USER: "onboarding/FAILURE_MIGRATION_UPDATE_USER",
    ACCEPT_TERMS_AND_CONDITIONS_FINISH_STEP_PF_REQUEST: "onboarding/ACCEPT_TERMS_AND_CONDITIONS_FINISH_STEP_PF_REQUEST",
    ACCEPT_TERMS_AND_CONDITIONS_FINISH_STEP_PJ_REQUEST: "onboarding/ACCEPT_TERMS_AND_CONDITIONS_FINISH_STEP_PJ_REQUEST",
    ACCEPT_TERMS_AND_CONDITIONS_FINISH_STEP_FAILURE: "onboarding/ACCEPT_TERMS_AND_CONDITIONS_FINISH_STEP_FAILURE",
    ACCEPT_TERMS_AND_CONDITIONS_FINISH_STEP_SUCCESS: "onboarding/ACCEPT_TERMS_AND_CONDITIONS_FINISH_STEP_SUCCESS",

    SET_ACCEPT_TERMS_AND_CONDITIONS_CHECKBOX_PF: "onboarding/SET_ACCEPT_TERMS_AND_CONDITIONS_CHECKBOX_PF",
    SET_ACCEPT_TERMS_AND_CONDITIONS_CHECKBOX_PJ: "onboarding/SET_ACCEPT_TERMS_AND_CONDITIONS_CHECKBOX_PJ",

    SET_ACCEPT_TOKEN_TERMS_AND_CONDITIONS_CHECKBOX: "onboarding/SET_ACCEPT_TOKEN_TERMS_AND_CONDITIONS_CHECKBOX",

    MIGRATION_SAVE_PERSONAL_DATA_REQUEST: "onboarding/MIGRATION_SAVE_PERSONAL_DATA_REQUEST",
    MIGRATION_SAVE_PERSONAL_DATA_FAILURE: "onboarding/MIGRATION_SAVE_PERSONAL_DATA_FAILURE",
    MIGRATION_SAVE_PERSONAL_DATA_SUCCESS: "onboarding/MIGRATION_SAVE_PERSONAL_DATA_SUCCESS",
};

export const INITIAL_STATE = {
    onboardingWithInvitation: null,
    invitationCodeRequest: { status: "INITIAL", value: "", error: null },
    invitationData: {
        firstName: "", // "Lautaro"
        lastName: "", // "Villar"
        documentType: "", // "DNI"
        documentCountry: "", // "AR"
        document: "", // "20312345057"
        cuil: "", // "20312345057"
        phoneNumber: {
            countryCode: "",
            areaCode: "",
            value: "",
        },
        mail: "", // "csalvatierra@technisys.com"
    },
    documentData: {
        documentCountry: null,
        documentNumber: null,
        firstName: null,
        fullDocument: null,
        lastName: null,
        dateOfBirth: null,
        gender: null,
        cuil: null,
    },
    documentAddress: null,
    documentType: "DNI",
    email: null,
    isUsernameAvailable: null,
    username: null,
    password: null,
    userData: null,
    passwordConfirmation: null,
    userCreationStatus: null,
    errors: null,
    error: null,
    exchangeToken: null,
    fetching: false,
    mobileNumber: null,
    picture: null,
    invitationCode: null,
    verificationCode: null,
    personalDataEnabled: null,
    secondFactorAuth: null,
    client: null,
    invitation: null,
    userCredentials: {
        password: "",
        passwordConfirmation: "",
        securitySeal: {
            id: "",
            image: undefined,
        },
    },
    securitySeals: {},
    address: {
        addressLine1: null,
        addressLine2: null,
        city: null,
        federalState: null,
        zipcode: null,
        residentSince: null,
    },
    states: [],
    jobs: [],
    occupation_options: [],
    source_of_wealth_options: [],
    annual_income_options: [],
    companyRoleList: [],
    maritalStatusList: [],
    occupationList: [],
    countryList: [],
    foreignCountries: [],
    onboardingUser: [],
    stateList: [],
    localityList: [],
    pepJobsList: [],
    pepRelationshipTypesList: [],
    SSNID: "",
    region: null,
    business: { name: "", status: "", data: {} },
    verifyCode: { type: "", status: "", data: {} },
    personalDataStatus: "",
    regulatoryDataStatus: "",
    errorValidateIdentity: null,
    errorValidateIdentityPermissions: false,
    scanDocumentInProgress: false,
    userRoleRequest: { status: "INITIAL", value: "", error: null },
    nosisCdaRequest: { status: "INITIAL", value: "", error: null, id: null },
    cuit: null,
    acceptRenaperTerms: false,
    identityValidationStarted: false,
    errorNewOperationVU: false,
    onboardingMainRole: null,
    errorMessage: "",
    signerUserExists: false,
    securitySeal: null,
    securitySealAlt: null,
    showCaptcha: false,
    onboardingWithEnrolledUser: false,
    enrolledUserRole: null,
    idEnvironment: null,
    acceptTermAndConditionsPF: false,
    acceptTermAndConditionsPJ: false,
    acceptTokenTermAndConditions: false,
    nationalities: [],
    genders: [],
    userMigrationStatus: null,
    documentFrontImage: null,
    documentBackImage: null,
    signer: null,
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        onboardingWithInvitation,
        invitationCodeRequest,
        documentCountry,
        documentNumber,
        documentType,
        email,
        errors,
        error,
        exchangeToken,
        firstName,
        fullDocument,
        lastName,
        gender,
        mobileNumber,
        picture,
        invitationCode,
        verificationCode,
        personalDataEnabled,
        client,
        invitation,
        secondFactorAuth,
        userCredentials,
        securitySeals,
        dateOfBirth,
        address,
        SSNID,
        business,
        verifyCode,
        isUsernameAvailable,
        username,
        password,
        passwordConfirmation,
        userCreationStatus,
        userData,
        companyRoleList,
        maritalStatusList,
        occupationList,
        countryList,
        foreignCountries,
        onboardingUser,
        cuit,
        stateList,
        localityList,
        pepJobsList,
        pepRelationshipTypesList,
        personalDataStatus,
        regulatoryDataStatus,
        errorValidateIdentity,
        errorValidateIdentityPermissions,
        userRoleRequest,
        nosisCdaRequest,
        cuil,
        onboardingMainRole,
        errorMessage,
        userExists,
        userMigrated,
        multiEnvironment,
        redirectStepUser,
        securitySeal,
        securitySealAlt,
        onboardingWithEnrolledUser,
        enrolledUserRole,
        idEnvironment,
        acceptTermAndConditionsPF,
        acceptTermAndConditionsPJ,
        acceptTokenTermAndConditions,
        nationalities,
        genders,
        userMigrationStatus,
        documentFrontImage,
        documentBackImage,
        invitationSigner,
    } = action;

    const documentData = {
        documentCountry,
        documentNumber,
        firstName,
        fullDocument,
        lastName,
        dateOfBirth,
        gender,
        cuil,
    };

    switch (action.type) {
        case types.SET_ONBOARDING_WITH_INVITATION:
            return { ...state, onboardingWithInvitation };
        case types.ONB_INVITATION_CODE_REQUEST:
            return {
                ...state,
                invitationCodeRequest: { status: "FETCHING", value: "", error: null },
            };
        case types.ONB_INVITATION_CODE_SUCCESS:
            return {
                ...state,
                invitationCodeRequest: { status: "SUCCESS", value: invitationCodeRequest, error: null },
                invitationData: invitationCodeRequest,
                signerUserExists: userExists,
                isUserMigrated: userMigrated,
                isMultiEnvironment: multiEnvironment,
                redirectStepUser,
                invitationCode,
                signer: invitationSigner,
            };
        case types.ONB_INVITATION_CODE_FAILURE:
            return {
                ...state,
                invitationCodeRequest: { status: "FAILURE", value: "", error: invitationCodeRequest },
            };
        case types.ONB_INVITATION_CODE_RESET:
            return {
                ...state,
                invitationCodeRequest: { status: "INITIAL", value: "", error: null },
            };

        case types.REQUEST_LIST_OCCUPATIONS:
            return { ...state };

        case types.SUCCESS_LIST_OCCUPATIONS:
            return {
                ...state,
                occupation_options: action.occupation_options,
                source_of_wealth_options: action.source_of_wealth_options,
                annual_income_options: action.annual_income_options,
                countryList: action.countryList,
                occupations: action.occupations,
            };

        case types.FAILURE_LIST_OCCUPATIONS:
            return {
                ...state,
                errors,
                fetching: false,
            };

        case types.REQUEST_LIST_JOBS:
            return { ...state };

        case types.SUCCESS_LIST_JOBS:
            return { ...state, jobs: action.jobs };

        case types.FAILURE_LIST_JOBS:
            return {
                ...state,
                errors,
                fetching: false,
            };

        case types.REQUEST_LIST_STATES:
            return { ...state };

        case types.SUCCESS_LIST_STATES:
            return { ...state, states: action.states };

        case types.FAILURE_LIST_STATES:
            return {
                ...state,
                errors,
                fetching: false,
            };

        case types.SET_EMAIL:
            return {
                ...state,
                email,
            };
        case types.SET_DOCUMENT_DATA:
            return {
                ...state,
                documentData: {
                    ...state.documentData,
                    ...documentData,
                },
            };
        case types.SET_DOCUMENT_TYPE:
            return {
                ...state,
                documentType,
            };
        case types.TAKE_PICTURE_ERROR:
            return {
                ...state,
                fetching: false,
            };
        case types.NEW_OPERATION_VU_REQUEST:
            return {
                ...state,
                fetching: true,
                errorValidateIdentity: null,
                errorNewOperationVU: false,
            };
        case types.NEW_OPERATION_VU_FAILURE:
            return {
                ...state,
                fetching: false,
                errorValidateIdentity,
                errorValidateIdentityPermissions,
                errorNewOperationVU: true,
            };
        case types.NEW_OPERATION_VU_SUCCESS:
            return {
                ...state,
                fetching: false,
                errorNewOperationVU: false,
            };
        case types.SCAN_DOCUMENT_REQUEST:
            return {
                ...state,
                fetching: true,
                errorValidateIdentity: null,
                errorValidateIdentityPermissions: false,
                scanDocumentInProgress: true,
                identityValidationStarted: true,
                documentFrontImage: null,
                documentBackImage: null,
            };
        case types.SCAN_DOCUMENT_REQUEST_BACK:
            return { ...state, scanDocumentInProgress: true };
        case types.SCAN_DOCUMENT_REQUEST_MIGRATION:
            return {
                ...state,
                fetching: true,
                errorValidateIdentity: null,
                errorValidateIdentityPermissions: false,
                scanDocumentInProgress: true,
                identityValidationStarted: true,
            };
        case types.SCAN_DOCUMENT_REQUEST_MIGRATION_BACK:
            return { ...state, scanDocumentInProgress: true };
        case types.CAPTURE_SELFIE_REQUEST:
            return {
                ...state,
                fetching: true,
                errorValidateIdentity: null,
                errorValidateIdentityPermissions: false,
            };
        case types.CAPTURE_SELFIE_MIGRATION:
            return {
                ...state,
                fetching: true,
                errorValidateIdentity: null,
                errorValidateIdentityPermissions: false,
            };
        case types.CAPTURE_SELFIE_MIGRATION_FAILURE:
            return {
                ...state,
                fetching: false,
                errorValidateIdentity,
                errorValidateIdentityPermissions: false,
            };
        case types.SCAN_DOCUMENT_SUCCESS_FRONT:
            return {
                ...state,
                fetching: false,
                documentFrontImage,
                scanDocumentInProgress: false,
            };
        case types.SCAN_DOCUMENT_SUCCESS:
            return {
                ...state,
                fetching: false,
                errorValidateIdentity: null,
                errorValidateIdentityPermissions: false,
                documentFrontImage,
                documentBackImage,
                documentData: {
                    ...documentData,
                    documentNumber,
                    firstName,
                    fullDocument: documentNumber,
                    lastName,
                    gender,
                    cuil: cuil !== "" ? cuil : null,
                },
                documentAddress: address,
                scanDocumentInProgress: false,
            };
        case types.SCAN_DOCUMENT_FAILURE:
            return {
                ...state,
                fetching: false,
                errorValidateIdentity,
                scanDocumentInProgress: false,
                errorValidateIdentityPermissions,
            };
        case types.CLEAN_SCAN_DOCUMENT_FLAG:
            return {
                ...state,
                scanDocumentInProgress: false,
            };
        case types.RESET_IDENTITY_VALIDATION_PROGRESS:
        case types.CAPTURE_SELFIE_SUCCESS:
            return {
                ...state,
                fetching: false,
                errorValidateIdentity: null,
                errorValidateIdentityPermissions: false,
            };
        case types.CAPTURE_SELFIE_FAILURE:
            return {
                ...state,
                fetching: false,
                errorValidateIdentity,
                errorValidateIdentityPermissions: false,
            };
        case types.TAKE_PICTURE_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.TAKE_PICTURE_SUCCESS:
            return {
                ...state,
                fetching: false,
                picture,
                exchangeToken,
            };
        case types.UPLOAD_CLIENT_INFO_AND_SEND_INVITATION_CODE_ERROR:
            return {
                ...state,
                errors,
                fetching: false,
            };
        case types.UPLOAD_CLIENT_PERSONAL_INFO_REQUEST:
            return {
                ...state,
                mobileNumber,
                SSNID,
            };
        case types.UPLOAD_CLIENT_PERSONAL_ADDRESS_REQUEST:
            return {
                ...state,
                address,
            };
        case types.UPLOAD_CLIENT_INFO_AND_SEND_INVITATION_CODE_SUCCESS:
            return {
                ...state,
                fetching: false,
            };

        case types.UPLOAD_PICTURE_ERROR:
            return {
                ...state,
                errors,
                exchangeToken,
                fetching: false,
            };
        case types.UPLOAD_PICTURE_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.UPLOAD_PICTURE_SUCCESS:
            return {
                ...state,
                error: null,
                exchangeToken,
                fetching: false,
            };
        case types.VERIFY_INVITATION_CODE_ERROR:
            return {
                ...state,
                fetching: false,
            };
        case types.VERIFY_INVITATION_CODE_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.VERIFY_INVITATION_CODE_SUCCESS:
            return {
                ...state,
                exchangeToken,
                fetching: false,
                invitationCode,
            };
        case types.REQUEST_VERIFICATION_CODE_PRE_ERROR:
            return {
                ...state,
                fetching: false,
            };
        case types.REQUEST_VERIFICATION_CODE_PRE_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.REQUEST_VERIFICATION_CODE_PRE_SUCCESS:
            return {
                ...state,
                client,
                fetching: false,
                invitation,
                personalDataEnabled,
                secondFactorAuth,
            };
        case types.VERIFY_VERIFICATION_CODE_ERROR:
            return {
                ...state,
                error,
                fetching: false,
            };
        case types.VERIFY_VERIFICATION_CODE_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.VERIFY_VERIFICATION_CODE_SUCCESS:
            return {
                ...state,
                exchangeToken,
                fetching: false,
                verificationCode,
            };
        case types.SAVE_USER_CREDENTIALS:
            return {
                ...state,
                userCredentials,
            };
        case types.CLEAN_USER_CREDENTIALS:
            return {
                ...state,
                userCredentials: INITIAL_STATE.userCredentials,
                documentData: INITIAL_STATE.documentData,
            };
        case types.SET_USER_CREDENTIALS_ERROR:
            return {
                ...state,
                fetching: false,
            };
        case types.SET_USER_CREDENTIALS_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.SET_USER_CREDENTIALS_SUCCESS:
            return {
                ...state,
                fetching: false,
                userCredentials: INITIAL_STATE.userCredentials,
            };
        case types.REQUEST_SECURITY_SEALS_ERROR:
            return {
                ...state,
                fetching: false,
            };
        case types.REQUEST_SECURITY_SEALS_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.REQUEST_SECURITY_SEALS_SUCCESS:
            return {
                ...state,
                exchangeToken,
                fetching: false,
                securitySeals,
            };
        case types.REQUEST_VERIFY_CUIT:
            return {
                ...state,
                business: { status: "", name: "", data: {} },
            };
        case types.SUCCESS_VERIFY_CUIT:
            return {
                ...state,
                business,
            };
        case types.FAILURE_VERIFY_CUIT:
            return {
                ...state,
                business: { status: "LIMIT_ERROR" },
            };
        case types.REQUEST_VERIFY_CODE_SEND:
            return {
                ...state,
                fetching: true,
                verifyCode: { type: "send", status: "", data: {} },
            };
        case types.SUCCESS_VERIFY_CODE_SEND:
            return {
                ...state,
                fetching: false,
                verifyCode,
            };
        case types.FAILURE_VERIFY_CODE_SEND:
            return {
                ...state,
                fetching: false,
            };
        case types.REQUEST_VERIFY_CODE_RECEIVE:
            return {
                ...state,
                fetching: true,
                verifyCode: { type: "receive", status: "", data: {} },
            };
        case types.REQUEST_VERIFY_CODE_RECEIVE_MIGRATION:
            return {
                ...state,
                fetching: true,
                verifyCode: { type: "receive", status: "", data: {} },
            };
        case types.SUCCESS_VERIFY_CODE_RECEIVE:
            return {
                ...state,
                fetching: false,
                verifyCode,
                email: verifyCode.status === "OK" && !!email ? email : state.email,
                mobileNumber: verifyCode.status === "OK" && !!mobileNumber ? state.mobileNumber : null,
            };
        case types.SUCCESS_VERIFY_CODE_RECEIVE_MIGRATION:
            return {
                ...state,
                fetching: false,
                verifyCode,
                email: verifyCode.status === "OK" && !!email ? email : state.email,
                mobileNumber: verifyCode.status === "OK" && !!mobileNumber ? state.mobileNumber : null,
            };
        case types.SET_MOBILE_NUMBER:
            return {
                ...state,
                mobileNumber: action.mobileNumber,
            };
        case types.FAILURE_VERIFY_CODE_RECEIVE:
            return {
                ...state,
                fetching: false,
                verifyCode,
            };
        case types.FAILURE_VERIFY_CODE_RECEIVE_MIGRATION:
            return {
                ...state,
                fetching: false,
                verifyCode,
            };
        case types.RESET_VERIFY_CODE:
            return {
                ...state,
                fetching: false,
                verifyCode: { type: "", status: "", data: {} },
            };
        case types.REQUEST_VERIFY_USERNAME:
            return {
                ...state,
                isUsernameAvailable: "",
            };
        case types.SUCCESS_VERIFY_USERNAME:
            return {
                ...state,
                isUsernameAvailable,
                username,
            };
        case types.FAILURE_VERIFY_USERNAME:
            return {
                ...state,
                isUsernameAvailable,
            };
        case types.SET_PASSWORD:
            return {
                ...state,
                password,
                passwordConfirmation,
            };
        case types.REQUEST_CREATE_USER:
            return {
                ...state,
                fetching: true,
                userCreationStatus: "",
            };
        case types.SUCCESS_CREATE_USER:
            return {
                ...state,
                fetching: false,
                userCreationStatus,
                errorMessage,
                idEnvironment,
            };
        case types.FAILURE_CREATE_USER:
            return {
                ...state,
                fetching: false,
                userCreationStatus,
                errorMessage,
            };
        case types.FAILURE_UNSECURE_PASSWORD:
            return {
                ...state,
                fetching: false,
                errorMessage,
            };

        case types.REQUEST_ACCEPT_SCHEME:
            return {
                ...state,
                fetching: true,
            };
        case types.SUCCESS_ACCEPT_SCHEME:
            return {
                ...state,
                fetching: false,
                userData,
            };
        case types.FAILURE_ACCEPT_SCHEME:
            return {
                ...state,
                fetching: false,
                userData,
            };

        case types.REQUEST_LIST_PERSONAL_INFO:
            return { ...state, fetching: true, personalDataStatus: "" };
        case types.SUCCESS_LIST_PERSONAL_INFO:
            return {
                ...state,
                companyRoleList: companyRoleList.reduce(
                    (newList, { stringId, shortDesc }) => [...newList, { value: stringId, label: shortDesc }],
                    [],
                ),
                maritalStatusList: maritalStatusList.reduce(
                    (newList, { stringId, shortDesc }) => [...newList, { value: stringId, label: shortDesc }],
                    [],
                ),
                occupationList: occupationList.reduce(
                    (newList, { stringId, shortDesc }) => [...newList, { value: stringId, label: shortDesc }],
                    [],
                ),
                countryList: countryList.reduce(
                    (newList, { id, name }) => [...newList, { value: id, label: name }],
                    [],
                ),
                stateList: stateList.reduce(
                    (newList, { nemotecnico, description, code }) => [
                        ...newList,
                        { value: nemotecnico, label: description, codeId: code },
                    ],
                    [],
                ),
                foreignCountries: foreignCountries.reduce(
                    (newList, { id, name }) => [...newList, { value: id, label: name }],
                    [],
                ),
                nationalities,
                genders,
                fetching: false,
            };
        case types.FAILURE_LIST_PERSONAL_INFO:
            return {
                ...state,
                errors,
                fetching: false,
            };
        case types.REQUEST_LIST_LOCALITY:
            return { ...state, fetching: true };
        case types.SUCCESS_LIST_LOCALITY:
            return {
                ...state,
                localityList: localityList.reduce(
                    (newList, { code, description }) => [...newList, { value: code, label: description }],
                    [],
                ),
                fetching: false,
            };
        case types.CLEAN_LOCALITY_LIST:
            return {
                ...state,
                localityList: [],
            };
        case types.FAILURE_LIST_LOCALITY:
            return {
                ...state,
                errors,
                fetching: false,
            };
        case types.REQUEST_SAVE_PERSONAL_DATA:
            return {
                ...state,
                fetching: true,
                personalDataStatus: "FETCHING",
            };
        case types.SUCCESS_SAVE_PERSONAL_DATA:
            return {
                ...state,
                fetching: false,
                personalDataStatus,
            };
        case types.FAILURE_SAVE_PERSONAL_DATA:
            return {
                ...state,
                fetching: false,
                personalDataStatus,
            };
        case types.REQUEST_GET_PERSONAL_DATA:
            return {
                ...state,
                fetching: true,
            };
        case types.SUCCESS_GET_PERSONAL_DATA:
            return {
                ...state,
                fetching: false,
            };
        case types.FAILURE_GET_PERSONAL_DATA:
            return {
                ...state,
                fetching: false,
                physicalPerson: false,
            };
        case types.REQUEST_LIST_REGULATORY_INFO:
            return { ...state, fetching: true, regulatoryDataStatus: "" };
        case types.SUCCESS_LIST_REGULATORY_INFO:
            return {
                ...state,
                pepJobsList: pepJobsList.reduce(
                    (newList, { stringId, shortDesc }) => [...newList, { value: stringId, label: shortDesc }],
                    [],
                ),
                pepRelationshipTypesList: pepRelationshipTypesList.reduce(
                    (newList, { stringId, shortDesc }) => [...newList, { value: stringId, label: shortDesc }],
                    [],
                ),
                countryList: countryList.reduce(
                    (newList, { id, name }) => [...newList, { value: id, label: name }],
                    [],
                ),

                fetching: false,
            };
        case types.FAILURE_LIST_REGULATORY_INFO:
            return {
                ...state,
                errors,
                fetching: false,
            };
        case types.REQUEST_LEGAL_REPRESENTATIVE_INFO:
            return { ...state, fetching: true, regulatoryDataStatus: "" };
        case types.SUCCESS_LEGAL_REPRESENTATIVE_INFO:
            return {
                ...state,
                fetching: false,
                onboardingUser,
                cuit,
            };
        case types.FAILURE_LEGAL_REPRESENTATIVE_INFO:
            return {
                ...state,
                errors,
                fetching: false,
            };
        // case types.REQUEST_SAVE_REGULATORY_DATA:
        //     return {
        //         ...state,
        //         fetching: true,
        //         regulatoryDataStatus: "FETCHING",
        //     };
        case types.SUCCESS_SAVE_REGULATORY_DATA:
            return {
                ...state,
                fetching: false,
                regulatoryDataStatus,
            };
        case types.FAILURE_SAVE_REGULATORY_DATA:
            return {
                ...state,
                fetching: false,
                regulatoryDataStatus,
            };
        case types.USER_ROLE_REQUEST:
            return {
                ...state,
                userRoleRequest: { status: "FETCHING", value: "", error: null },
            };
        case types.USER_ROLE_SUCCESS:
            return {
                ...state,
                userRoleRequest: { status: "SUCCESS", value: userRoleRequest, error: null },
            };
        case types.USER_ROLE_FAILURE:
            return {
                ...state,
                userRoleRequest: { status: "FAILURE", value: "", error: userRoleRequest },
            };
        case types.NOSIS_CDA_REQUEST:
            return {
                ...state,
                nosisCdaRequest: { status: "FETCHING", value: "", error: null, id: documentNumber },
            };
        case types.NOSIS_CDA_SUCCESS:
            return {
                ...state,
                nosisCdaRequest: { status: "SUCCESS", value: nosisCdaRequest, error: null, id: documentNumber },
                onboardingMainRole,
            };
        case types.NOSIS_CDA_FAILURE:
            return {
                ...state,
                nosisCdaRequest: { status: "FAILURE", value: "", error: nosisCdaRequest, id: documentNumber },
            };
        case types.NOSIS_CDA_RESET:
            return {
                ...state,
                nosisCdaRequest: { status: "INITIAL", value: "", error: null, id: null },
            };
        case types.SET_ACCEPT_RENAPER_TERMS:
            return { ...state, acceptRenaperTerms: action.accept };
        case types.SET_IDENTITY_VALIDATION_STARTED:
            return { ...state, identityValidationStarted: true };
        case types.RESTART_ENVIRONMENT_STORE:
            return INITIAL_STATE;
        case types.VALIDATE_CREDENTIALS_STEP_1_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.VALIDATE_CREDENTIALS_STEP_1_SUCCESS:
            return {
                ...state,
                fetching: false,
                showCaptcha: false,
                exchangeToken,
                securitySeal,
                securitySealAlt,
                username,
            };
        case types.VALIDATE_CREDENTIALS_STEP_1_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.VALIDATE_CREDENTIALS_STEP_1_MIGRATION_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.VALIDATE_CREDENTIALS_STEP_1_MIGRATION_SUCCESS:
            return {
                ...state,
                fetching: false,
                showCaptcha: false,
                exchangeToken,
                securitySeal,
                securitySealAlt,
                username,
            };
        case types.VALIDATE_CREDENTIALS_STEP_1_MIGRATION_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.VALIDATE_CREDENTIALS_STEP_2_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.VALIDATE_CREDENTIALS_STEP_2_SUCCESS:
            return {
                ...state,
                fetching: false,
                showCaptcha: false,
            };
        case types.VALIDATE_CREDENTIALS_STEP_2_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.VALIDATE_CREDENTIALS_STEP_2_MIGRATION_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.VALIDATE_CREDENTIALS_STEP_2_MIGRATION_SUCCESS:
            return {
                ...state,
                business,
                fetching: false,
                showCaptcha: false,
            };
        case types.VALIDATE_CREDENTIALS_STEP_2_MIGRATION_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.SET_ONBOARDING_WITH_ENROLLED_USER:
            if (onboardingWithEnrolledUser) {
                return {
                    ...state,
                    onboardingWithEnrolledUser,
                    onboardingWithInvitation: null,
                    invitationCodeRequest: { status: "INITIAL", value: "", error: null },
                };
            }
            return { ...state, onboardingWithEnrolledUser };
        case types.ENROLLED_USER_SELECT_ROLE_REQUEST:
            return {
                ...state,
                fetching: true,
                enrolledUserRole,
            };
        case types.ENROLLED_USER_SELECT_ROLE_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.ENROLLED_USER_SELECT_ROLE_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.ACCEPT_TERMS_AND_CONDITIONS_FINISH_STEP_PF_REQUEST:
            return { ...state, fetching: true };
        case types.ACCEPT_TERMS_AND_CONDITIONS_FINISH_STEP_PJ_REQUEST:
        case types.REQUEST_MIGRATION_UPDATE_USER:
            return {
                ...state,
                fetching: true,
            };
        case types.SUCCESS_MIGRATION_UPDATE_USER:
            return {
                ...state,
                fetching: false,
                userMigrationStatus,
                errorMessage,
            };
        case types.FAILURE_MIGRATION_UPDATE_USER:
            return {
                ...state,
                fetching: false,
                userMigrationStatus,
                errorMessage,
            };
        case types.ACCEPT_TERMS_AND_CONDITIONS_FINISH_STEP_REQUEST:
            return { ...state, fetching: true };
        case types.ACCEPT_TERMS_AND_CONDITIONS_FINISH_STEP_FAILURE:
            return { ...state, fetching: false };
        case types.ACCEPT_TERMS_AND_CONDITIONS_FINISH_STEP_SUCCESS:
            return { ...state, fetching: false };
        case types.SET_ACCEPT_TERMS_AND_CONDITIONS_CHECKBOX_PF:
            return { ...state, fetching: false, acceptTermAndConditionsPF };
        case types.SET_ACCEPT_TERMS_AND_CONDITIONS_CHECKBOX_PJ:
            return { ...state, fetching: false, acceptTermAndConditionsPJ };
        case types.MIGRATION_SAVE_PERSONAL_DATA_REQUEST:
            return {
                ...state,
                fetching: true,
                personalDataStatus: "FETCHING",
            };
        case types.MIGRATION_SAVE_PERSONAL_DATA_SUCCESS:
            return {
                ...state,
                fetching: false,
                personalDataStatus,
            };
        case types.MIGRATION_SAVE_PERSONAL_DATA_FAILURE:
            return {
                ...state,
                fetching: false,
                personalDataStatus,
            };

        case types.SET_ACCEPT_TOKEN_TERMS_AND_CONDITIONS_CHECKBOX:
            return { ...state, fetching: false, acceptTokenTermAndConditions };
        default:
            return state;
    }
};

export const actions = {
    setOnboardingWithInvitation: (onboardingWithInvitation) => ({
        type: types.SET_ONBOARDING_WITH_INVITATION,
        onboardingWithInvitation,
    }),
    verifyOnbInvitationCode: (_code) => ({
        type: types.ONB_INVITATION_CODE_REQUEST,
        _code,
    }),
    resetInvitationCodeRequest: () => ({
        type: types.ONB_INVITATION_CODE_RESET,
    }),
    listSelectorsOptionsRequest: () => ({
        type: types.REQUEST_LIST_SELECTOR_OPTIONS,
    }),
    listOccupationsRequest: () => ({
        type: types.REQUEST_LIST_OCCUPATIONS,
    }),
    listOccupationsSuccess: (jobs) => ({
        type: types.REQUEST_LIST_OCCUPATIONS,
        jobs,
    }),
    listJobsRequest: () => ({
        type: types.REQUEST_LIST_JOBS,
    }),
    listJobsSuccess: (jobs) => ({
        type: types.REQUEST_LIST_JOBS,
        jobs,
    }),
    listStatesRequest: () => ({
        type: types.REQUEST_LIST_STATES,
    }),
    listStateSuccess: (states) => ({
        type: types.REQUEST_LIST_STATES,
        states,
    }),
    setEmail: (email) => ({
        type: types.SET_EMAIL,
        email,
    }),
    setDocumentType: (documentType) => ({
        type: types.SET_DOCUMENT_TYPE,
        documentType,
    }),
    takePicture: (currentStep, documentSide = null, picture, exchangeToken = null) => ({
        type: types.TAKE_PICTURE_REQUEST,
        currentStep,
        documentSide,
        picture,
        exchangeToken,
    }),
    takePictureError: () => ({
        type: types.TAKE_PICTURE_ERROR,
    }),
    uploadClientPersonalInfo: (documentNumber, email, firstName, formikBag, lastName, mobileNumber, SSNID) => ({
        type: types.UPLOAD_CLIENT_PERSONAL_INFO_REQUEST,
        documentNumber,
        email,
        firstName,
        formikBag,
        lastName,
        mobileNumber,
        SSNID,
    }),
    uploadClientPersonalAddress: (formikBag, address) => ({
        type: types.UPLOAD_CLIENT_PERSONAL_ADDRESS_REQUEST,
        formikBag,
        address,
    }),
    uploadClientInfoAndSendInvitationCode: (
        documentNumber,
        email,
        firstName,
        formikBag,
        lastName,
        mobileNumber,
        address,
        jobInformation,
        SSNID,
        region,
    ) => ({
        type: types.UPLOAD_CLIENT_INFO_AND_SEND_INVITATION_CODE_REQUEST,
        documentNumber,
        email,
        firstName,
        formikBag,
        lastName,
        mobileNumber,
        address,
        jobInformation,
        SSNID,
        region,
    }),
    uploadPicture: (documentType, exchangeToken, picture, rotatePicture) => ({
        type: types.UPLOAD_PICTURE_REQUEST,
        documentType,
        exchangeToken,
        picture,
        rotatePicture,
    }),
    verifyInvitationCode: (invitationCode, formikBag) => ({
        type: types.VERIFY_INVITATION_CODE_REQUEST,
        invitationCode,
        formikBag,
    }),
    verifyVerificationCode: (verificationCode, formikBag) => ({
        type: types.VERIFY_VERIFICATION_CODE_REQUEST,
        verificationCode,
        formikBag,
    }),
    requestVerificationCodePre: (invitationCode, exchangeToken) => ({
        type: types.REQUEST_VERIFICATION_CODE_PRE_REQUEST,
        invitationCode,
        exchangeToken,
    }),
    saveUserCredentials: (userCredentials) => ({
        type: types.SAVE_USER_CREDENTIALS,
        userCredentials,
    }),
    cleanUserCredentials: () => ({
        type: types.CLEAN_USER_CREDENTIALS,
    }),
    setUserCredentials: (password, passwordConfirmation, securitySealId, username, formikBag) => ({
        type: types.SET_USER_CREDENTIALS_REQUEST,
        password,
        passwordConfirmation,
        securitySealId,
        username,
        formikBag,
    }),
    requestSecuritySeals: (exchangeToken) => ({
        type: types.REQUEST_SECURITY_SEALS_REQUEST,
        exchangeToken,
    }),
    verifyCUIT: (cuit, exchangeToken) => ({
        type: types.REQUEST_VERIFY_CUIT,
        cuit,
        exchangeToken,
    }),
    generateNewOperationVU: (exchangeToken) => ({
        type: types.NEW_OPERATION_VU_REQUEST,
        exchangeToken,
    }),
    scanDocumentRequest: (exchangeToken, guestFlow = false) => ({
        type: types.SCAN_DOCUMENT_REQUEST,
        exchangeToken,
        guestFlow,
    }),
    scanDocumentRequestBack: (exchangeToken, guestFlow = false) => ({
        type: types.SCAN_DOCUMENT_REQUEST_BACK,
        exchangeToken,
        guestFlow,
    }),
    scanDocumentRequestMigration: (exchangeToken, guestFlow = false) => ({
        type: types.SCAN_DOCUMENT_REQUEST_MIGRATION,
        exchangeToken,
        guestFlow,
    }),
    scanDocumentRequestMigrationBack: (exchangeToken, guestFlow = false) => ({
        type: types.SCAN_DOCUMENT_REQUEST_MIGRATION_BACK,
        exchangeToken,
        guestFlow,
    }),
    captureSelfieRequest: (document, gender, exchangeToken, guestFlow = false) => ({
        type: types.CAPTURE_SELFIE_REQUEST,
        document,
        gender,
        exchangeToken,
        guestFlow,
    }),
    captureSelfieMigration: (document, gender, exchangeToken, guestFlow = false) => ({
        type: types.CAPTURE_SELFIE_MIGRATION,
        document,
        gender,
        exchangeToken,
        guestFlow,
    }),
    verifyCodeSend: (verificationMethod, _userEmail, _userPhoneNumber, preferenceToken = false, businessName) => ({
        type: types.REQUEST_VERIFY_CODE_SEND,
        verificationMethod,
        _userEmail,
        _userPhoneNumber,
        preferenceToken,
        businessName,
    }),
    verifyCodeReceive: (
        _code,
        verificationMethod,
        _userEmail,
        _userPhoneNumber,
        exchangeToken,
        guestFlow = false,
        preferenceToken = false,
    ) => ({
        type: types.REQUEST_VERIFY_CODE_RECEIVE,
        _code,
        verificationMethod,
        _userEmail,
        _userPhoneNumber,
        guestFlow,
        exchangeToken,
        preferenceToken,
    }),
    verifyCodeReceiveMigration: (
        _code,
        verificationMethod,
        _userEmail,
        _userPhoneNumber,
        exchangeToken,
        guestFlow = false,
        preferenceToken = false,
    ) => ({
        type: types.REQUEST_VERIFY_CODE_RECEIVE_MIGRATION,
        _code,
        verificationMethod,
        _userEmail,
        _userPhoneNumber,
        guestFlow,
        exchangeToken,
        preferenceToken,
    }),
    resetVerifyCode: () => ({
        type: types.RESET_VERIFY_CODE,
    }),
    setUsername: (username) => ({
        type: types.REQUEST_VERIFY_USERNAME,
        username,
    }),
    setPassword: (password, passwordConfirmation) => ({
        type: types.SET_PASSWORD,
        password,
        passwordConfirmation,
    }),
    createUser: (userData, exchangeToken) => ({
        type: types.REQUEST_CREATE_USER,
        userData,
        _exchangeToken: exchangeToken,
    }),
    acceptScheme: (idUser, idEnvironment) => ({
        type: types.REQUEST_ACCEPT_SCHEME,
        idUser,
        idEnvironment,
    }),
    savePersonalData: (personalData, documentType, document, gender, exchangeToken, guestFlow = false) => ({
        type: types.REQUEST_SAVE_PERSONAL_DATA,
        personalData,
        documentType,
        document,
        gender,
        guestFlow,
        _exchangeToken: exchangeToken,
    }),
    getPersonalData: (document, exchangeToken) => ({
        type: types.REQUEST_GET_PERSONAL_DATA,
        document,
        _exchangeToken: exchangeToken,
    }),
    // saveRegulatoryData: (document, documentType, gender, regulatoryData, exchangeToken, guestFlow = false) => ({
    //     type: types.REQUEST_SAVE_REGULATORY_DATA,
    //     document,
    //     documentType,
    //     gender,
    //     regulatoryData,
    //     _exchangeToken: exchangeToken,
    //     guestFlow,
    // }),
    listPersonalInfoRequest: (guestFlow) => ({
        type: types.REQUEST_LIST_PERSONAL_INFO,
        guestFlow,
    }),
    listLocalityRequest: (countryCode, provinceCode) => ({
        type: types.REQUEST_LIST_LOCALITY,
        countryCode,
        provinceCode,
    }),
    cleanLocalityList: () => ({
        type: types.CLEAN_LOCALITY_LIST,
    }),
    listRegulatoryInfoRequest: () => ({
        type: types.REQUEST_LIST_REGULATORY_INFO,
    }),
    legalRepresentativeInfoRequest: () => ({
        type: types.REQUEST_LEGAL_REPRESENTATIVE_INFO,
    }),
    resetPersonalDataStatus: () => ({
        type: types.SUCCESS_SAVE_PERSONAL_DATA,
        personalDataStatus: "",
    }),
    resetRegulatoryDataStatus: () => ({
        type: types.SUCCESS_SAVE_REGULATORY_DATA,
        regulatoryDataStatus: "",
    }),
    getUserRole: () => ({
        type: types.USER_ROLE_REQUEST,
    }),
    getNosisCda: (documentData) => ({
        type: types.NOSIS_CDA_REQUEST,
        ...documentData,
    }),
    resetNosisCda: () => ({
        type: types.NOSIS_CDA_RESET,
    }),
    setAcceptRenaperTerms: (accept) => ({
        type: types.SET_ACCEPT_RENAPER_TERMS,
        accept,
    }),
    setIdentityValidationStarted: () => ({
        type: types.SET_IDENTITY_VALIDATION_STARTED,
    }),
    resetIdentityValidationProgress: () => ({
        type: types.RESET_IDENTITY_VALIDATION_PROGRESS,
    }),
    setMobileNumber: (mobileNumber) => ({
        type: types.SET_MOBILE_NUMBER,
        mobileNumber,
    }),
    restartOnboardingStore: () => ({
        type: types.RESTART_ENVIRONMENT_STORE,
    }),
    verifyUserCredentialsStep1: (_username, usernameSecret) => ({
        type: types.VALIDATE_CREDENTIALS_STEP_1_REQUEST,
        _username,
        usernameSecret,
    }),
    verifyUserCredentialsStep1Migration: (_username, usernameSecret) => ({
        type: types.VALIDATE_CREDENTIALS_STEP_1_MIGRATION_REQUEST,
        _username,
        usernameSecret,
    }),
    verifyUserCredentialsStep2: (username, password) => ({
        type: types.VALIDATE_CREDENTIALS_STEP_2_REQUEST,
        username,
        password,
    }),
    verifyUserCredentialsStep2Migration: (username, password) => ({
        type: types.VALIDATE_CREDENTIALS_STEP_2_MIGRATION_REQUEST,
        username,
        password,
    }),
    setOnboardingWithEnrolledUser: (onboardingWithEnrolledUser) => ({
        type: types.SET_ONBOARDING_WITH_ENROLLED_USER,
        onboardingWithEnrolledUser,
    }),
    enrolledUserSelectRole: (enrolledUserRole) => ({
        type: types.ENROLLED_USER_SELECT_ROLE_REQUEST,
        enrolledUserRole,
    }),
    updateMigratedUser: (userData, exchangeToken) => ({
        type: types.REQUEST_MIGRATION_UPDATE_USER,
        userData,
        _exchangeToken: exchangeToken,
    }),
    acceptTermsAndConditionsFinishStepPF: (category, exchangeToken) => ({
        type: types.ACCEPT_TERMS_AND_CONDITIONS_FINISH_STEP_PF_REQUEST,
        category,
        exchangeToken,
    }),
    acceptTermsAndConditionsFinishStepPJ: (category) => ({
        type: types.ACCEPT_TERMS_AND_CONDITIONS_FINISH_STEP_PJ_REQUEST,
        category,
    }),
    acceptTermsAndConditionsPF: (acceptTermAndConditionsPF) => ({
        type: types.SET_ACCEPT_TERMS_AND_CONDITIONS_CHECKBOX_PF,
        acceptTermAndConditionsPF,
    }),
    acceptTermsAndConditionsPJ: (acceptTermAndConditionsPJ) => ({
        type: types.SET_ACCEPT_TERMS_AND_CONDITIONS_CHECKBOX_PJ,
        acceptTermAndConditionsPJ,
    }),
    saveMigrationPersonalData: (personalData, document, gender, exchangeToken) => ({
        type: types.MIGRATION_SAVE_PERSONAL_DATA_REQUEST,
        personalData,
        document,
        gender,
        _exchangeToken: exchangeToken,
    }),

    acceptTokenTermsAndConditions: (acceptTokenTermAndConditions) => ({
        type: types.SET_ACCEPT_TOKEN_TERMS_AND_CONDITIONS_CHECKBOX,
        acceptTokenTermAndConditions,
    }),
};

export const selectors = {
    getOnboardingWithInvitation: ({ onboarding }) => onboarding.onboardingWithInvitation,
    getInvitationCodeRequest: ({ onboarding }) => onboarding.invitationCodeRequest,
    getInvitationData: ({ onboarding }) => onboarding.invitationData,
    getDocumentData: ({ onboarding }) => onboarding.documentData,
    getFirstName: ({ onboarding }) => onboarding.documentData.firstName,
    getDocumentNumber: ({ onboarding }) => onboarding.documentData.documentNumber,
    getDocumentType: ({ onboarding }) => onboarding.documentType,
    getEmail: ({ onboarding }) => onboarding.email,
    getErrors: ({ onboarding }) => onboarding.errors,
    getExchangeToken: ({ onboarding }) => onboarding.exchangeToken,
    getFetching: ({ onboarding }) => onboarding.fetching,
    getMobileNumber: ({ onboarding }) => onboarding.mobileNumber,
    getPicture: ({ onboarding }) => onboarding.picture,
    getInvitationCode: ({ onboarding }) => onboarding.invitationCode,
    getPersonalDataEnabled: ({ onboarding }) => onboarding.personalDataEnabled,
    getUserCredentials: ({ onboarding }) => onboarding.userCredentials,
    getClient: ({ onboarding }) => onboarding.client,
    getInvitation: ({ onboarding }) => onboarding.invitation,
    getVerificationCode: ({ onboarding }) => onboarding.verificationCode,
    getSecuritySeals: ({ onboarding }) => onboarding.securitySeals,
    getAddress: ({ onboarding }) => onboarding.address,
    getStates: ({ onboarding }) => onboarding.states,
    getOccupation_options: ({ onboarding }) => onboarding.occupation_options,
    getSource_of_wealth_options: ({ onboarding }) => onboarding.source_of_wealth_options,
    getAnnual_income_options: ({ onboarding }) => onboarding.annual_income_options,
    getCountryList: ({ onboarding }) => onboarding.countryList,
    getForeignCountries: ({ onboarding }) => onboarding.foreignCountries,
    getOccupations: ({ onboarding }) => onboarding.occupations,
    getSSNID: ({ onboarding }) => onboarding.SSNID,
    getBusiness: ({ onboarding }) => onboarding.business,
    getVerifyCode: ({ onboarding }) => onboarding.verifyCode,
    getUsername: ({ onboarding }) => onboarding.username,
    getIsUsernameAvailable: ({ onboarding }) => onboarding.isUsernameAvailable,
    getPassword: ({ onboarding }) => onboarding.password,
    getPasswordConfirmation: ({ onboarding }) => onboarding.passwordConfirmation,
    getUserCreationStatus: ({ onboarding }) => onboarding.userCreationStatus,
    getStateList: ({ onboarding }) => onboarding.stateList,
    getLocalityList: ({ onboarding }) => onboarding.localityList,
    getCompanyRoleList: ({ onboarding }) => onboarding.companyRoleList,
    getMaritalStatusList: ({ onboarding }) => onboarding.maritalStatusList,
    getOccupationList: ({ onboarding }) => onboarding.occupationList,
    getPepJobsList: ({ onboarding }) => onboarding.pepJobsList,
    getDataUser: ({ onboarding }) => onboarding.onboardingUser,
    getPepRelationshipTypesList: ({ onboarding }) => onboarding.pepRelationshipTypesList,
    getDocumentAddress: ({ onboarding }) => onboarding.documentAddress,
    getPersonalDataStatus: ({ onboarding }) => onboarding.personalDataStatus,
    getRegulatoryDataStatus: ({ onboarding }) => onboarding.regulatoryDataStatus,
    getErrorValidateIdentity: ({ onboarding }) => onboarding.errorValidateIdentity,
    geterrorValidateIdentityPermissions: ({ onboarding }) => onboarding.errorValidateIdentityPermissions,
    getScanDocumentInProgress: ({ onboarding }) => onboarding.scanDocumentInProgress,
    getUserRoleRequest: ({ onboarding }) => onboarding.userRoleRequest,
    getNosisCdaRequest: ({ onboarding }) => onboarding.nosisCdaRequest,
    getCuitUser: ({ onboarding }) => onboarding.cuit,
    getAcceptRenaperTerms: ({ onboarding }) => onboarding.acceptRenaperTerms,
    getIdentityValidationStarted: ({ onboarding }) => onboarding.identityValidationStarted,
    getErrorNewOperationVU: ({ onboarding }) => onboarding.errorNewOperationVU,
    getOnboardingMainRole: ({ onboarding }) => onboarding.onboardingMainRole,
    getSignerUserExists: ({ onboarding }) => onboarding.signerUserExists,
    getIsUserMigrated: ({ onboarding }) => onboarding.isUserMigrated,
    getIsMultiEnvironment: ({ onboarding }) => onboarding.isMultiEnvironment,
    getRedirectStepUser: ({ onboarding }) => onboarding.redirectStepUser,
    getSecuritySeal: ({ onboarding }) => onboarding.securitySeal,
    getSecuritySealAlt: ({ onboarding }) => onboarding.securitySealAlt,
    getShowCaptcha: ({ onboarding }) => onboarding.showCaptcha,
    getOnboardingWithEnrolledUser: ({ onboarding }) => onboarding.onboardingWithEnrolledUser,
    enrolledUserRole: ({ onboarding }) => onboarding.enrolledUserRole,
    getIdEnvironment: ({ onboarding }) => onboarding.idEnvironment,
    getAcceptTermConditionsPF: ({ onboarding }) => onboarding.acceptTermAndConditionsPF,
    getAcceptTermConditionsPJ: ({ onboarding }) => onboarding.acceptTermAndConditionsPJ,
    getNationalities: ({ onboarding }) => onboarding.nationalities,
    getGenders: ({ onboarding }) => onboarding.genders,
    getUserMigrationStatus: ({ onboarding }) => onboarding.userMigrationStatus,
    getDocumentFrontImage: ({ onboarding }) => onboarding.documentFrontImage,
    getDocumentBackImage: ({ onboarding }) => onboarding.documentBackImage,
    getAcceptTokenTermConditions: ({ onboarding }) => onboarding.acceptTokenTermAndConditions,
    getSigner: ({ onboarding }) => onboarding.signer,
};
